import { Filter } from 'lucide-react';
import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

interface EnumFilterProps {
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  placeholder?: string;
}

export const EnumFilter: React.FC<EnumFilterProps> = ({
  value,
  onChange,
  options,
  placeholder = 'Filter...',
}) => {
  const selectedOption = options.find((option) => option.value === value);

  const handleOptionClick = (optionValue: string) => {
    if (value === optionValue) {
      // If clicking the same option, clear it
      onChange('');
    } else {
      // Select the new option
      onChange(optionValue);
    }
  };

  const handleClear = () => {
    onChange('');
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className="h-4 w-4 text-text-muted hover:text-text-primary cursor-pointer relative"
          title={selectedOption ? selectedOption.label : placeholder}
        >
          <Filter className="h-4 w-4 translate-y-0.5" />
          {value && (
            <span className="absolute -top-1 -right-1 h-3 w-3 bg-primary text-primary-foreground text-xs rounded-full flex items-center justify-center">
              •
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-48 p-2" align="start">
        <div className="space-y-1">
          {options.map((option) => (
            <button
              key={option.value}
              onClick={() => handleOptionClick(option.value)}
              className={`w-full text-left px-2 py-1 text-sm rounded hover:bg-gray-100 ${
                value === option.value
                  ? 'bg-primary text-primary-foreground'
                  : ''
              }`}
            >
              {option.label}
            </button>
          ))}
          {value && (
            <div className="pt-2 border-t">
              <Button
                variant="ghost"
                size="sm"
                onClick={handleClear}
                className="w-full text-xs"
              >
                Löschen
              </Button>
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
